module.exports = __webpack_public_path__ + "static/media/commitment.968fba27.png";